import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
const hoeKunnenWeJeHelpenStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['400'])};
	padding: ${pxToRem(theme.spacing['400'])};
	background-color: ${theme.colors.blanc.bgFormField};
	border-radius: ${pxToRem(theme.borderRadius.m)};

	h2,
	p {
		color: #000307;
	}

	ul {
		display: flex;
		flex-direction: column;
		gap: ${pxToRem(theme.spacing['200'])};
		list-style-type: none;
		padding: 0;
		margin: 0;
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
		gap: ${pxToRem(theme.spacing['450'])};
	}
`;
export const StyledHoeKunnenWeJeHelpen = styled.div `
	${hoeKunnenWeJeHelpenStyles}
`;
const hoeKunnenWeJeHelpenGroupStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['300'])};

	> * {
		margin: 0;
		padding: 0;
	}
`;
export const StyledHoeKunnenWeJeHelpenGroup = styled.div `
	${hoeKunnenWeJeHelpenGroupStyles}
`;
